import React, { useState } from 'react';
import CostOfBreakingRules from './CostOfBreakingRules';
import PlaybookFitScore from './PlaybookFitScore';

const PlaybookROI = ({ costData, fitData, costLoading, fitLoading }) => {
  const [view, setView] = useState('cost');

  return (
    <div>
      {/* Toggle header */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          Playbook ROI
        </span>
        <div className="flex items-center gap-1 bg-muted rounded-md p-0.5">
          <button
            onClick={() => setView('cost')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              view === 'cost'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Rule Cost
          </button>
          <button
            onClick={() => setView('fit')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              view === 'fit'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Fit Score
          </button>
        </div>
      </div>

      {view === 'cost' && (
        <CostOfBreakingRules data={costData} loading={costLoading} />
      )}
      {view === 'fit' && (
        <PlaybookFitScore data={fitData} loading={fitLoading} />
      )}
    </div>
  );
};

export default PlaybookROI;
